import api from '../../../services/api';
import { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import { useForm } from "react-hook-form";
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import PageContainer from '../../../common/components/PageContainer';
import useAlerta from '../../../common/components/useAlerta';
import AppSnackbar from '../../../common/components/AppSnackbar';

function MercadoriaItem() {
    const [item, setItem] = useState({});
    const { id } = useParams();
    const [imageData, setImageData] = useState(null);
    const { alerta, mostrarAlerta, fecharAlerta } = useAlerta();
    const { register, handleSubmit, reset } = useForm();

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            convertToBase64(file);
        }
    };

    const convertToBase64 = (file) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
            setImageData(reader.result);
        };
        reader.onerror = (error) => {
            console.error('Erro ao converter a imagem para Base64:', error);
        };
    };

    const onSubmit = async (data) => {
        if (!imageData) {
            console.error('Nenhuma imagem foi selecionada.');
            return;
        }

        const formData = {
            ...data,
            foto: imageData,
        };

        try {
            await api.put(`/mercadoria/${id}`, formData);
            mostrarAlerta('Item atualizado com sucesso!', 'success');
            setTimeout(() => {
                window.location.href = '/mercadoria';
            }, 1500);
        } catch (error) {
            mostrarAlerta('Erro ao atualizar o item!', 'error');
        }
        setTimeout(fecharAlerta, 3000);
    };

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await api.get(`/mercadoria/${id}`);
                setItem(response.data);
                reset(response.data);
                if (response.data.foto) {
                    setImageData(`data:image/jpeg;base64,${response.data.foto}`);
                }
            } catch (error) {
                console.error('Erro ao buscar o item:', error);
            }
        }

        fetchData();
    }, [id, reset]);

    return (
        <PageContainer sx={{ maxWidth: 700 }}>
            <Paper component="form" onSubmit={handleSubmit(onSubmit)} sx={{ p: { xs: 2, sm: 4 } }}>
                <Typography variant="h5" sx={{ color: 'primary.main', fontWeight: 600, mb: 3 }}>
                    {item.nome}
                </Typography>

                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
                    <Avatar src={imageData || undefined} variant="rounded" sx={{ width: 96, height: 96, bgcolor: 'primary.light' }}>
                        {!imageData && <Inventory2OutlinedIcon fontSize="large" />}
                    </Avatar>
                </Box>

                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <TextField {...register("nome")} label="Nome" required fullWidth InputLabelProps={{ shrink: true }} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField {...register("unidMedida")} label="Unidade de medida" required fullWidth InputLabelProps={{ shrink: true }} />
                    </Grid>
                    <Grid item xs={12}>
                        <Button variant="outlined" component="label" fullWidth>
                            Selecionar nova foto
                            <input
                                {...register("foto")}
                                type="file"
                                accept="image/*"
                                hidden
                                onChange={handleFileChange}
                            />
                        </Button>
                    </Grid>
                </Grid>

                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                    <Button type="submit" variant="contained" color="secondary" size="large" sx={{ px: 6 }}>
                        Atualizar
                    </Button>
                </Box>
            </Paper>

            <AppSnackbar alerta={alerta} onClose={fecharAlerta} />
        </PageContainer>
    );
}

export default MercadoriaItem;
